import { render, staticRenderFns } from "./productsDetail.vue?vue&type=template&id=1e78d996&scoped=true"
import script from "./productsDetail.vue?vue&type=script&lang=js"
export * from "./productsDetail.vue?vue&type=script&lang=js"
import style0 from "./productsDetail.vue?vue&type=style&index=0&id=1e78d996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e78d996",
  null
  
)

export default component.exports